<template>
  <footer class="footer bg-light py-3 fixed-bottom">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start">
          &copy; 2023 {{ this.$store.getters.appName }}
        </div>
        <div class="col-md-6 text-center text-md-end">
          <span class="text-muted">Version 1.0.0</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar'
}
</script>

<style scoped>
.footer {
  height: 56px; /* Fixez une hauteur */
  z-index: 1020;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
</style>